import z from 'zod';
import {firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {progressWriteSchema} from './progressWriteSchema';

/**
 * Document shape as stored in Firestore: users/{uid}/progress/{examModuleId}.
 * id is the examModuleId (document id) when reading.
 */
export const progressDbSchema = progressWriteSchema.extend({
  lastUpdated: firestoreTimestampSchema,
});

export interface ProgressDb extends z.infer<typeof progressDbSchema> {}
